// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    HOMEPAGE_VIDEO_LOADING() {
      return {
        isLoading: true,
        homepageVideo: action.homepageVideo
      };
    },
    HOMEPAGE_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.homepageVideo
      };
    },
    HOMEPAGE_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.homepageVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
